import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Breadcrumb from 'components/ui/Breadcrumb';
import { getUserProfile } from '../../../services/user';
import appUrls from '../../../appUrls';

const useStyles = makeStyles((theme) => ({
    mainHeading: {
        margin: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            textAlign: 'center'
        }
    },
    breadcrumbs: {
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center'
        }
    }
}));

function UserProfileViewPage(props) {
    const classes = useStyles();

    const navigate = useNavigate();

    const [profileDetails, setProfileDetails] = useState();
    const [profileDetailsLoading, setProfileDetailsLoading] = useState(true);

    useEffect(() => {
        async function fetchUserProfile() {
            setProfileDetailsLoading(true);
            const result = await getUserProfile();
            if (result.error === false) {
                const userData = {
                    ...result.user,
                    userId: result.user._id,
                    contactNumber: result.user.contactNumber,
                    name: result.user.name,
                    image: { url: '', key: '', new: false, loading: false }
                };
                if (result?.user?.image) {
                    userData.image = {
                        url: `${result.imageBaseUrl}/${result?.user?.image}`,
                        key: '',
                        new: false,
                        loading: false
                    };
                } else {
                    userData.image = { url: '', key: '', new: false, loading: false };
                }
                setProfileDetails(userData);
            }
            setProfileDetailsLoading(false);
            console.log('-> result', result);
        }

        fetchUserProfile();
    }, []);

    return (
        <>
            <Breadcrumb title="User Profile" />
            <Grid container justifyContent="center">
                <Grid item xs={12} lg={11} xl={9}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-end'
                                        }}
                                    >
                                        <Button variant="outlined" onClick={() => navigate(appUrls.PROFILE_EDIT)}>
                                            Edit
                                        </Button>
                                    </Box>
                                    <Box p={1}>
                                        {profileDetailsLoading ? (
                                            'Loading...'
                                        ) : (
                                            <Grid container>
                                                <Grid item xs={12} md={6} px={3}>
                                                    <Box
                                                        sx={{
                                                            width: '100%',
                                                            height: '100%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <Avatar
                                                            src={profileDetails?.image?.url}
                                                            alt={profileDetails?.name}
                                                            sx={{ width: 150, height: 150 }}
                                                            title={profileDetails?.name}
                                                        />
                                                    </Box>

                                                    {/* <img style={{ width: '100%' }} src={profileDetails?.image?.url} alt="user" /> */}
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6}>
                                                            <Typography variant="h4">Full Name</Typography>
                                                            <Typography variant="body">{profileDetails?.name}</Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography variant="h4">Email</Typography>
                                                            <Typography variant="body">{profileDetails?.email}</Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography variant="h4">Institute</Typography>
                                                            <Typography variant="body">{profileDetails?.institute?.name}</Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography variant="h4">Yearbook</Typography>
                                                            <Typography variant="body">{profileDetails?.yearBook?.name}</Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography variant="h4">Phone Number</Typography>
                                                            <Typography variant="body">
                                                                {/* eslint-disable */}
                                                                {profileDetails?.contactNumber
                                                                    ? profileDetails?.contactNumber
                                                                    : profileDetails?.contactNumber?.trim().length === 0
                                                                    ? '-'
                                                                    : profileDetails?.contactNumber}
                                                                {/* eslint-enable */}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default UserProfileViewPage;
